import { useQuery } from '@tanstack/react-query';
import { useCompany } from '@/contexts/CompanyContext';
import { useDirection } from '@/contexts/DirectionContext';
import { latestOffersApi } from '../api/latestOffers.api';
import type { LatestOfferRow } from '../interfaces/latestOffers.interface';

interface UseLatestOffersResult {
  data: LatestOfferRow[] | undefined;
  isLoading: boolean;
  isFetching: boolean;
  error: Error | null;
  refresh: () => void;
}

export function useLatestOffers(): UseLatestOffersResult {
  const { selectedCompanyId } = useCompany();
  const { direction } = useDirection();
  const companyId = typeof selectedCompanyId === 'number' ? selectedCompanyId : undefined;

  const query = useQuery<LatestOfferRow[]>({
    queryKey: ['dashboard', 'latest-offers', selectedCompanyId, direction],
    queryFn: () => latestOffersApi.get(companyId, direction),
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
  });

  return {
    data: query.data,
    isLoading: query.isLoading,
    isFetching: query.isFetching,
    error: (query.error as Error) || null,
    refresh: () => {
      void query.refetch();
    },
  };
}
